export interface IPage<T> {
  entities: T[];
  count: number;
}

export class Page<T> implements IPage<T> {
  constructor(public entities: T[], public count: number) { }
}
